import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["borderColor", "onChatInputChanged", "value", "onKeyDown", "disabled", "restrictedPlaceholder", "placeholder", "toolbar", "icon", "inputRef", "role", "maxHeight", "shrink", "minHeight"];
import { GYPSUM, KOALA, OLAF } from 'HubStyleTokens/colors';
import UIExpandingTextArea from 'UIComponents/input/UIExpandingTextArea';
import UIBox from 'UIComponents/layout/UIBox';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import styled from 'styled-components';
import { BLACK, MAGENTA } from '../../styles/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BreezeTextInputWrapper = styled(UIBox).withConfig({
  displayName: "AICopilotTextInput__BreezeTextInputWrapper",
  componentId: "sc-4wha9t-0"
})(["border:", ";position:relative;padding:8px 12px;background-color:", " !important;border-radius:", ";"], ({
  borderColor
}) => `1px solid ${borderColor}`, OLAF, ({
  hasToolbar
}) => hasToolbar ? '12px' : '22px');
const BreezeExpandingTextInput = styled(UIExpandingTextArea).withConfig({
  displayName: "AICopilotTextInput__BreezeExpandingTextInput",
  componentId: "sc-4wha9t-1"
})(["font-size:14px;flex-grow:1;border:none !important;width:90%;&:focus{box-shadow:none !important;}background-color:", ";padding:0;min-height:", ";line-height:", ";"], OLAF, props => props.hasToolbar ? 'auto' : '22px', props => props.hasToolbar ? 'inherit' : '20px');
export const AcceptedColors = [BLACK.NEUTRAL, MAGENTA[400]];
const AICopilotTextInput = _ref => {
  let {
      borderColor = MAGENTA[400],
      onChatInputChanged,
      value,
      onKeyDown,
      disabled,
      restrictedPlaceholder,
      placeholder,
      toolbar,
      icon,
      inputRef,
      role,
      maxHeight = 200,
      shrink = true,
      minHeight
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const hasToolbar = Boolean(toolbar);
  return /*#__PURE__*/_jsx(Flex, {
    paddingBlockStart: "200",
    paddingBlockEnd: "200",
    flexDirection: "column",
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(BreezeTextInputWrapper, {
      borderColor: borderColor,
      disabled: !!disabled,
      hasToolbar: hasToolbar,
      alignSelf: "stretch",
      style: {
        backgroundColor: restrictedPlaceholder ? KOALA : GYPSUM
      },
      children: !restrictedPlaceholder ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(BreezeExpandingTextInput, Object.assign({}, props, {
          hasToolbar: hasToolbar,
          autoFocus: true,
          inputRef: inputRef,
          maxHeight: maxHeight,
          minHeight: minHeight,
          onChange: onChatInputChanged,
          onKeyDown: onKeyDown,
          placeholder: placeholder,
          resize: false,
          role: role,
          shrink: shrink,
          value: value
        })), hasToolbar && /*#__PURE__*/_jsx(View, {
          paddingBlockStart: "300",
          children: toolbar
        }), icon]
      }) : /*#__PURE__*/_jsx(Text, {
        color: "text-primary-disabled",
        children: restrictedPlaceholder
      })
    })
  });
};
export default AICopilotTextInput;